/* Dark modules on a light field, always — see `QrCode.tsx`. The colours are tokens of their own and
   not the surface's, so a theme that darkened the card would still leave a code a scanner can read. */

.code {
  display: block;
  width: 100%;
  max-width: 220px;
  height: auto;
  margin: 0 auto 14px;
  border: 1px solid var(--line);
  border-radius: 6px;
}

.light {
  fill: var(--qr-light);
}

.dark {
  fill: var(--qr-dark);
}
